export default __webpack_public_path__ + "static/media/heart-grey.b5012636.svg";